<template>
  <div>
    <!-- begin TC info -->
    <div class="order_confirm_panel spacing">
      <div class="panel_underline_title">
        <span>{{ $t("CONFIRMATION.TITLE6") }}</span>
      </div>
      <div class="form">
        <el-row :gutter="10">
          <el-col :xs="24" :lg="12" v-for="(item, index) in this.$objBaseInfo.customerTcs" :key="'tc' + index">
            <div class="grid-content">
              <div class="f-label-field">{{ $i18n.locale == "zh" ? item.keyName : item.keyENName }}</div>
              <div class="lable_value_review">{{ item.keyValue }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- end TC info -->
    <!-- begin MI info -->
    <div class="order_confirm_panel spacing">
    <div class="panel_underline_title">
      <span>{{ $t("CONFIRMATION.MIINFO") }}</span>
    </div>
    <div class="form" v-if="this.$objBaseInfo.sourceType != 'CRM' || !OrderData.isUpdate">
      <el-row :gutter="10">
        <el-col :xs="24" :lg="24" v-for="(item, index) in OrderData.orderInfo.miInfoList" :key="'MI' + index">
          <div class="grid-content" v-if="item.pageShow == 1">
            <div class="f-label-field">{{item.miNameDic? item.miNameDic[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]: ""}}</div>
            <div class="lable_value_review">{{item.miDropName? item.miDropName[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]: item.miValue}}</div>
          </div>
          <el-col style="padding-right: 5px;width:90%;" :xs="24" :lg="24" v-if="$objBaseInfo.channelId == 'MOBILE'">
            <a style="word-break:break-word;" class="miNoteFont" :class="[(item.noteLink!='' && item.noteLink!='javascript:void(0)') ?'miNoteFontT':'miNoteFontF']" href="javascript:void(0)" @click="(item.noteLink!='' && item.noteLink!='javascript:void(0)') && MobileMINoteLink(item)">{{ item.note }}</a>
          </el-col>
          <el-col style="padding-right: 5px;width:90%;" :xs="24" :lg="24" v-if="$objBaseInfo.channelId == 'WEB'">
            <a style="word-break:break-word;" class="miNoteFont" :class="[(item.noteLink!='' && item.noteLink!='javascript:void(0)') ?'miNoteFontT':'miNoteFontF']" :href="item.noteLink" 
            :target="[(item.noteLink!='' && item.noteLink!='javascript:void(0)') ?'_blank':'']">{{ item.note }}</a>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div class="form" v-if="this.$objBaseInfo.sourceType == 'CRM' && OrderData.isUpdate">
      <el-row style="margin: 0 -5px 1rem;display: block;">
        <el-form :model="OrderData.updateOrderForm" ref="updateOrderForm" label-width="8rem" label-position="top">
          <div v-for="(item, index) in OrderData.miList" :key="'miDialog' + index">
            <el-col :xs="24" :lg="24" v-if="item.textTypeCode === 'text'">
              <el-form-item :label=" $i18n.locale == 'zh' ? item.miNameCN : item.miNameEN" :prop="item.relationMIKey"
              :rules="[{ required: item.needResult == 1,message:$i18n.locale == 'zh'? '请输入' + item.miNameCN: 'Please input ' + item.miNameEN,trigger: 'blur',},
                       { pattern: new RegExp(eval2(item.textValue.regularStr)),message:$i18n.locale == 'zh'? '请输入正确的' + item.miNameCN: 'Please input the correct ' + item.miNameEN,},
                      ]" class="form-label-field">
                <el-input v-model="OrderData.updateOrderForm[item.relationMIKey]" @input="miDropChange($event, item)" :maxlength=" item.textValue.textLength == 0? 100: item.textValue.textLength"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24" v-if="item.textTypeCode === 'down'">
              <el-form-item :label="$i18n.locale == 'zh' ? item.miNameCN : item.miNameEN"
              :rules="[{ required: item.needResult == 1,message:$i18n.locale == 'zh'? '请输入' + item.miNameCN: 'Please input ' + item.miNameEN,trigger: 'change',},]"
              :prop="item.relationMIKey" class="form-label-field">
                <el-select v-model="OrderData.updateOrderForm[item.relationMIKey]" @change="miDropChange($event, item)">
                  <el-option v-for="itemL in item.dropDowns" :key="itemL.nameCN" :label="$i18n.locale == 'zh' ? itemL.nameCN : itemL.nameEN" :value="itemL.downCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="padding-right: 5px;width:90%;" :xs="24" :lg="24" v-if="$objBaseInfo.channelId == 'MOBILE'">
              <a style="word-break:break-word;" class="miNoteFont" :class="[(item.noteLink!='' && item.noteLink!='javascript:void(0)') ?'miNoteFontT':'miNoteFontF']" href="javascript:void(0)" 
              @click="(item.noteLink!='' && item.noteLink!='javascript:void(0)') && MobileMINoteLink(item)">{{ item.note }}</a>
            </el-col>
            <el-col style="padding-right: 5px;width:90%;" :xs="24" :lg="24" v-if="$objBaseInfo.channelId == 'WEB'">
              <a style="word-break:break-word;" class="miNoteFont" :class="[(item.noteLink!='' && item.noteLink!='javascript:void(0)') ?'miNoteFontT':'miNoteFontF']" :href="item.noteLink" 
              :target="[(item.noteLink!='' && item.noteLink!='javascript:void(0)') ?'_blank':'']">{{ item.note }}</a>
            </el-col>
          </div>
        </el-form>
      </el-row>
    </div>
    </div>
    <!-- end MI info -->
    <!-- begin Special Requirement -->
    <div class="order_confirm_panel spacing" v-if="OrderData.orderInfo.specialRequests != ''">
      <div class="panel_underline_title">
        <span>{{ $t("CONFIRMATION.TITLE3") }}</span>
      </div>
      <div class="special_req">
        <p>{{OrderData.orderInfo.special1? OrderData.orderInfo.special1[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]: ""}}</p>
        <p>{{OrderData.orderInfo.special2? OrderData.orderInfo.special2[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]: ""}}</p>
      </div>
    </div>
    <!-- end Special Requirement -->
    <!-- begin RC info -->
    <div class="order_confirm_panel spacing" v-if="OrderData.isShowPOSRC">
      <div class="panel_underline_title">
        <span>{{ $t('BOOKING.ReasonCode') }}</span>
      </div>
      <div class="form">
        <el-row :gutter="10" style="margin: 0 -5px 1rem">
          <div class="grid-content">
            <div class="special_req" style="height: auto;">{{ getPOSRCTextValue }}</div>
          </div>
        </el-row>
      </div>
    </div>
    <!-- end RC info -->
  </div>
</template>
<script>
import {eval2} from "@/utils/utils.js";
export default {
  name: "confirmationSpecial",
  inject: ['OrderData'],
  data() {
    return {
      eval2:eval2,
    };
  },
  mounted() {
  },
  created(){
    console.log(this.OrderData.isUpdate)
  },
  
  computed:{
    getPOSRCTextValue(){
      let text="";
      let arr=this.OrderData.POSRCTextValue.split("-");
      if(arr.length==1)
      {
        return this.OrderData.POSRCTextValue;
      }
      if(this.$i18n.locale == "en")
      {
        if(arr.length>=3)
          text=arr[2];
        else
          text=arr[0];
      }
      else
      {
        text=arr[1];
      }
      return text;
    },
  },
  methods:{
    MobileMINoteLink(item){
      let link="";
      if(this.$i18n.locale == "en"){
        if(item.noteENLink!=undefined && item.noteENLink!=null)
        {
          link=item.noteENLink;
        }
      }else{
        if(item.noteCNLink!=undefined && item.noteCNLink!=null)
        {
          link=item.noteENLink;
        }
      }
      if(link!=""){
        window.open(link,"");
      }
    },
    //动态MI下拉框
    miDropChange(val1, item) {
      this.OrderData.updateOrderForm[item.relationMIKey] = val1;
      if (item.textTypeCode === "down") {
        let obj = item.dropDowns.find((e) => {
          return e.downCode === val1;
        });
        this.OrderData.updateOrderForm[item.relationMIKey + "Name"] =
          this.$i18n.locale == "zh" ? obj.miNameCN : obj.miNameEN;
      }
      this.$forceUpdate();
    },
  }
}
</script>
<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
 
  .order_confirm_panel {
    background-color: #fff;
    padding: 1.3rem;
    font-size: 1.4rem;

    &.spacing {
      margin-bottom: 1.3rem;
    }

    .span_icon:not(:last-child) {
      height: 100%;
    }

    svg {
      margin-right: 1rem;
      flex: 1;
    }

    .confirm_text {
      font-size: 1.8rem;
      height: 2.8rem;
      line-height: 2.8rem;
    }
  }
  .panel_underline_title {
    border-bottom: 0.2rem solid $btn-bg-color;
    padding-bottom: 1.2rem;
    font-weight: bold;
  }

  .lable_value_review {
    width: 90%;
    height: 2.7rem;
    line-height: 2.7rem;
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
  }

  .special_req {
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
    margin-top: 1.3rem;

    p {
      line-height: 2.7rem;
    }
  }
  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1.5rem;
      color: $text-fill-color;
    }

    ::v-deep .el-input__inner {
      height: 2.7rem;
      line-height: 2.7rem;
    }
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {

  .order_confirm_panel {
    background-color: #fff;
    padding: 1.3rem;
    font-size: 1.4rem;

    &.spacing {
      margin-bottom: 1.3rem;
    }

    .span_icon:not(:last-child) {
      height: 100%;
    }

    svg {
      margin-right: 1rem;
      flex: 1;
    }

    .confirm_text {
      font-size: 1.8rem;
      height: 2.8rem;
      line-height: 2.8rem;
    }
  }

  .panel_underline_title {
    border-bottom: 0.2rem solid $btn-bg-color;
    padding-bottom: 1.2rem;
    font-weight: bold;
  }
  .lable_value_review {
    width: 90%;
    height: 2.7rem;
    line-height: 2.7rem;
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
  }

  .special_req {
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
    margin-top: 1.3rem;

    p {
      line-height: 2.7rem;
    }
  }
  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1.5rem;
      color: $text-fill-color;
    }

    ::v-deep .el-input__inner {
      height: 2.7rem;
      line-height: 2.7rem;
    }
  }
}
.miNoteFont{
  color:rgb(111, 120, 126);
  font-size:1.4rem;
}
.miNoteFontT{
  cursor:pointer;
  text-decoration:underline;
}
.miNoteFontF{
  cursor:default;
  text-decoration:none;
}
</style>
